import { Outlet } from "react-router";
import SettingsMenu from "./menu/SettingsMenu";
import SettingsLayout from "./SettingsLayout";

const InvestorSettings = () => {
  return (
    <SettingsLayout menu={<SettingsMenu />}>
      <Outlet />
    </SettingsLayout>
  );
};

export default InvestorSettings;
